import type { CardHooks, CardHookCtx } from "./registry";
/** Bloodforged Plate — armor passive.
 *
 * When you play an attack action that deals damage, gain 1 Blood counter on this armor. Each Blood
 * counter expended grants +1 power for the next attack. Does not Clear at round end.
 *
 * Implementation note: the "pendingPowerBuff" is added to the player's combat
 * state by playAttack when the card is played, so it automatically applies to
 * the next attack and then clears. The onAttackPlay hook just adds 1 to the
 */
export const bloodforgedPlate: CardHooks = {
  onDamageDealt: (ctx: CardHookCtx) => {
    if ((ctx.damageDealt ?? 0) <= 0) return {};
    if (!ctx.self.armorActive) return {};
    if (ctx.self.armorCardId !== ctx.card.id) return {};

    return {
      selfPatch: {
        armorBloodCounters: (ctx.self.armorBloodCounters ?? 0) + 1,
      },
      log: [`${ctx.card.name} gains 1 Blood counter.`],
    };
  },
  onAttackPlay: (ctx) => {
    // `attacksThisRound` is incremented BEFORE this hook fires in
    // playAttackDefend, so on the 2nd attack of the round it reads 2.
    if (ctx.self.attacksThisRound === 2) {
      return {
        drawSelf: 1,
        log: ["Bloodforged Plate — 2nd attack this round draws a card."],
      };
    }
    return {};
  }
};
